import { NAV_LIST_ITEMS } from 'site-settings/site-navigation';
import config from '../../config';

import {
  StyledNavigationList,
  StyledNavigationLink,
  StyledNavigationItem
} from './main-navigation-list.style';
import {useAppSelector} from "../../redux/use-hooks";
import {selectAccountId} from "../../redux/slices/account";
const  {PLANT_LIST}=config

const MainNavigationList = () => {
  const accountId = useAppSelector(selectAccountId);
  const inList = PLANT_LIST.includes(accountId)
  const list = inList?NAV_LIST_ITEMS:NAV_LIST_ITEMS.filter(item=>item.id !=='menu.plant')
  return (
    <StyledNavigationList>
      {list.map(({ id, to, text }) => (
        <StyledNavigationItem key={id}>
          <StyledNavigationLink data-text={text} to={to} end>
            {text}
          </StyledNavigationLink>
        </StyledNavigationItem>
      ))}
    </StyledNavigationList>
  );
};

export default MainNavigationList;
